import cloneDeep from 'lodash/fp/cloneDeep'
import history from '../../../core/history'
import { validateProfileForApproval } from '../../../common/forms/validationFunctions'

import { events as containerEvents } from './adviserProfileEditorContainerActions'
import { events as blurbEvents } from '../AdviserProfileBlurbEditor/adviserProfileBlurbEditorActions'
import { events as languagesEvents } from '../AdviserProfileLanguagePreferencesEditor/adviserProfileLanguagePreferencesEditorActions'
import { events as investmentMinimumsEvents } from '../AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorActions'
import { events as clientTypesEvents } from '../AdviserProfileClientTypesEditor/adviserProfileClientTypesEditorActions'
import { events as areasOfSpecialisationEvents } from '../AdviserProfileAreasOfSpecialisationEditor/adviserProfileAreasOfSpecialisationEditorActions'
import { events as conflictDeclarationsEvents } from '../AdviserProfileConflictDeclarationsEditor/adviserProfileConflictDeclarationsEditorActions'
import { events as educationEvents } from '../AdviserProfileEducationEditor/adviserProfileEducationEditorActions'
import { events as submitForApprovalEvents } from '../AdviserProfileSubmitForApproval/adviserProfileSubmitForApprovalActions'
import { events as contactDetailsEvents } from '../AdviserProfileContactDetailsEditor/adviserProfileContactDetailsEditorActions'
import { events as picturesEditorEvents } from '../AdviserProfilePicturesEditor/adviserProfilePicturesEditorActions'
import { events as workExperienceEvents } from '../AdviserProfileWorkExperienceEditor/adviserProfileWorkExperienceEditorActions'

import adviserProfilePicturesEditorReducer from '../AdviserProfilePicturesEditor/adviserProfilePicturesEditorReducer'
import adviserProfileBlurbEditorReducer from '../AdviserProfileBlurbEditor/adviserProfileBlurbEditorReducer'
import adviserProfileInvestmentMinimumsEditorReducer from '../AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorReducer'
import adviserProfileLanguagePreferencesEditorReducer from '../AdviserProfileLanguagePreferencesEditor/adviserProfileLanguagePreferencesEditorReducer'
import adviserProfileClientTypesEditorReducer from '../AdviserProfileClientTypesEditor/adviserProfileClientTypesEditorReducer'
import adviserProfileAreasOfSpecialisationEditorReducer from '../AdviserProfileAreasOfSpecialisationEditor/adviserProfileAreasOfSpecialisationEditorReducer'
import adviserProfileConflictDeclarationsEditorReducer from '../AdviserProfileConflictDeclarationsEditor/adviserProfileConflictDeclarationsEditorReducer'
import adviserProfileEducationEditorReducer from '../AdviserProfileEducationEditor/adviserProfileEducationEditorReducer'
import adviserProfileSubmitForApprovalReducer from '../AdviserProfileSubmitForApproval/adviserProfileSubmitForApprovalReducer'
import adviserProfileWorkExperienceEditorReducer from '../AdviserProfileWorkExperienceEditor/adviserProfileWorkExperienceEditorReducer'
import adviserProfileContactDetailsEditorReducer, { validatePhoneNumber, validateEmail, contactDetailsFormIsValid } from '../AdviserProfileContactDetailsEditor/adviserProfileContactDetailsEditorReducer'

const intialProfile = {
  yearsAverageClientRetention: null,
  distanceToAdvisor: null,
  contactDetails: {
    email: '',
    phoneNumber: '',
    faxNumber: '',
    address: ''
  },
  languagePreferences: [],
  adviserId: null,
  profilePic: null,
  companyLogo: null,
  company: '',
  companyAddress: '',
  companyWebsite: '',
  title: '',
  blurb: '',
  isIndependent: false,
  adviserName: '',
  investmentMinimums: {
    minimumLumpSum: null,
    minimumMonthlyDebitOrder: null
  },
  qualifications: [],
  workExperiences: [],
  areasOfSpecialisation: [],
  clientTypePreferences: [],
  rating: {
    average: null,
    totalReviews: null
  },
  financialServicesOffered: []
}

const localStorage = global.localStorage
let token = null
let adviserName = ''
if (localStorage) {
  token = localStorage.getItem('token')
  adviserName = localStorage.getItem('userName')
}

const initialState = {
  blurb: adviserProfileBlurbEditorReducer(undefined, {}),
  investmentMinimums: adviserProfileInvestmentMinimumsEditorReducer(undefined, {}),
  languagePreferences: adviserProfileLanguagePreferencesEditorReducer(undefined, {}),
  conflictDeclarations: adviserProfileConflictDeclarationsEditorReducer(undefined, {}),
  clientTypes: adviserProfileClientTypesEditorReducer(undefined, {}),
  areasOfSpecialisation: adviserProfileAreasOfSpecialisationEditorReducer(undefined, {}),
  education: adviserProfileEducationEditorReducer(undefined, {}),
  contactDetails: adviserProfileContactDetailsEditorReducer(undefined, {}),
  profilePictures: adviserProfilePicturesEditorReducer(undefined, {}),
  submissionForApproval: adviserProfileSubmitForApprovalReducer(undefined, {}),
  experiences: adviserProfileWorkExperienceEditorReducer(undefined, {}),
  profile: intialProfile,
  edited: false,
  agToken: '',
  adviserIsLoggedIn: token !== null,
  adviserName: adviserName,
  token: token,
  loading: true,
  loginFailed: false,
  adviserId: getAdviserId(),
  readyForApproval: false,
  invalidArray: [],
  editingProfile: false,
  submittingProfile: false,
  submittedProfile: false,
  containerIsValid: false,
  fetchedContactNumberTypes: false,
  allContactNumberTypes: []
}

const validateProfile = (state) => {
  state.adviserId = state.profile?.adviserId;

  const validationstate = validateProfileForApproval(state.profile || {});
  state.readyForApproval = validationstate.valid;
  state.invalidArray = validationstate.invalidArr;

  const {
    blurb,
    languagePreferences,
    investmentMinimums,
    conflictDeclarations,
    clientTypes,
    areasOfSpecialisation,
    contactDetails
  } = state;

  // 🛡️ Ensure validationstate exists
  if (!contactDetails.validationstate) {
    contactDetails.validationstate = {
      contactNumbers: { valid: false },
      publicContactEmailAddress: { valid: false },
      formIsValid: false
    };
  }


  // -------------------------
  // 📞 Contact Numbers
  // -------------------------
  const numbers = state.profile?.contactDetails?.contactNumbers || [];


  if (numbers.length === 0) {
  
    contactDetails.validationstate.contactNumbers = {
      valid: false,
      message: "Please enter your contact number"
    };
  } else {
    const firstNumber = numbers[0]?.contactNumber;

   
    const phoneValidationResult = validatePhoneNumber(firstNumber);

   
    contactDetails.validationstate.contactNumbers = phoneValidationResult;
  }

  // -------------------------
  // 📧 Email Validation
  // -------------------------
  const email = state.profile?.contactDetails?.publicContactEmailAddress || "";

   const emailValidationResult = validateEmail(email);

  
  contactDetails.validationstate.publicContactEmailAddress =
    emailValidationResult;

  // -------------------------
  // 📋 Form Validation
  // -------------------------
  contactDetails.isInvalid = contactDetails.isInvalid || {};
  contactDetails.isInvalid.contactNumbers =
    contactDetails.validationstate.contactNumbers;
  contactDetails.isInvalid.publicContactEmailAddress =
    contactDetails.validationstate.publicContactEmailAddress;

  const formValid = contactDetailsFormIsValid(state);

  
  contactDetails.validationstate.formIsValid = formValid;

  
  
// Each sub-state stores its validity under `isInvalid.formIsValid` (languagePreferences
// is double-nested); only contactDetails uses `validationstate.formIsValid`. Reading the
// correct field for each — and coercing to a boolean — prevents containerIsValid from
// being `undefined`, which broke the Submit-for-approval validity and the prop-type checks.
state.containerIsValid = Boolean(
  blurb?.isInvalid?.formIsValid &&
  investmentMinimums?.isInvalid?.formIsValid &&
  languagePreferences?.languagePreferences?.isInvalid?.formIsValid &&
  conflictDeclarations?.isInvalid?.formIsValid &&
  clientTypes?.isInvalid?.formIsValid &&
  areasOfSpecialisation?.isInvalid?.formIsValid &&
  contactDetails?.validationstate?.formIsValid
);


  return state;
};


export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case blurbEvents.edit.start:
    case blurbEvents.edit.stop:
    case blurbEvents.edit.cancel:
    case blurbEvents.set.firstName:
    case blurbEvents.set.middleName:
    case blurbEvents.set.lastName:
    case blurbEvents.set.investorTitle:
    case blurbEvents.set.investorCompany:
    case blurbEvents.set.investorCompanyWebsite:
    case blurbEvents.set.investorBuildingDetails:
    case blurbEvents.set.investorStreetAddress:
    case blurbEvents.set.investorSuburb:
    case blurbEvents.set.investorPostalCode:
    case blurbEvents.set.investorCity:
    case blurbEvents.set.investorDescription:
      newState = adviserProfileBlurbEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case languagesEvents.edit.start:
    case languagesEvents.edit.stop:
    case languagesEvents.edit.cancel:
    case languagesEvents.fetch.fetched:
    case languagesEvents.set.selectionChanged:
      newState = adviserProfileLanguagePreferencesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case clientTypesEvents.edit.start:
    case clientTypesEvents.edit.stop:
    case clientTypesEvents.edit.cancel:
    case clientTypesEvents.fetch.fetched:
    case clientTypesEvents.set.selectionChanged:
      newState = adviserProfileClientTypesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case areasOfSpecialisationEvents.edit.start:
    case areasOfSpecialisationEvents.edit.cancel:
    case areasOfSpecialisationEvents.fetch.fetched:
    case areasOfSpecialisationEvents.set.selectionChanged:
      newState = adviserProfileAreasOfSpecialisationEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case investmentMinimumsEvents.edit.start:
    case investmentMinimumsEvents.edit.stop:
    case investmentMinimumsEvents.edit.cancel:
    case investmentMinimumsEvents.set.minimumLumpSum:
    case investmentMinimumsEvents.set.minimumMonthlyDebitOrder:
    case investmentMinimumsEvents.set.allowUnsureInvestors:
      newState = adviserProfileInvestmentMinimumsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case conflictDeclarationsEvents.edit.start:
    case conflictDeclarationsEvents.edit.stop:
    case conflictDeclarationsEvents.edit.cancel:
    case conflictDeclarationsEvents.fetch.fetched:
    case conflictDeclarationsEvents.set.selectionChanged:
    case conflictDeclarationsEvents.set.isIndependent:
      newState = adviserProfileConflictDeclarationsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case picturesEditorEvents.set.profilePic:
    case picturesEditorEvents.edit.profilePic.start:
    case picturesEditorEvents.edit.profilePic.stop:
    case picturesEditorEvents.edit.profilePic.cancel:
    case picturesEditorEvents.upload.profilePic.uploading:
    case picturesEditorEvents.upload.profilePic.uploaded:
    case picturesEditorEvents.edit.companyPic.start:
    case picturesEditorEvents.edit.companyPic.stop:
    case picturesEditorEvents.edit.companyPic.cancel:
    case picturesEditorEvents.set.companyPic:
    case picturesEditorEvents.upload.companyPic.uploading:
    case picturesEditorEvents.upload.companyPic.uploaded:
    case picturesEditorEvents.edit.start:
    case picturesEditorEvents.edit.stop:
      newState = adviserProfilePicturesEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case submitForApprovalEvents.submit.submitting:
    case submitForApprovalEvents.submit.submitted:
      newState = adviserProfileSubmitForApprovalReducer(newState, action)
      return newState
    case educationEvents.add.qualification:
    case educationEvents.edit.start:
    case educationEvents.edit.stop:
    case educationEvents.edit.cancel:
    case educationEvents.set.qualification:
    case educationEvents.set.startMonth:
    case educationEvents.set.endMonth:
    case educationEvents.set.startYear:
    case educationEvents.set.endYear:
    case educationEvents.set.endDateCurrent:
    case educationEvents.deletes.modal:
    case educationEvents.deletes.qualification:
    case educationEvents.deletes.cancel:
      newState = adviserProfileEducationEditorReducer(newState, action)
      return newState
    case containerEvents.fetch.fetching:
      newState.loading = true
      return newState
    case containerEvents.fetch.fetchingPendingProfile:
      newState.loading = true
      return newState
    case containerEvents.fetch.fetched: {
  newState.loading = false

  const profile = setProfileDefaults(action.payload)
  newState.profile = profile

  newState.contactDetails.contactNumbers =
    profile.contactDetails?.contactNumbers || []

  newState.contactDetails.publicContactEmailAddress =
    profile.contactDetails?.publicContactEmailAddress || ""

  newState = validateProfile(newState)
  // Reset any stale "submitted for approval" flag so this freshly-loaded profile can be
  // submitted again. Without this the flag is never reset, so after the first submission
  // of any profile in the session the button stays stuck disabled.
  newState.submissionForApproval.submitted = false
  newState.submissionForApproval.submitting = false
  return newState
    }
    case containerEvents.fetch.fetchedPendingProfile:
      newState.loading = false
      newState.hasPendingProfile = !!action.payload['adviserId']
      return newState
    case contactDetailsEvents.add.contactNumber:
    case contactDetailsEvents.set.contactNumber:
    case contactDetailsEvents.set.publicEmail:
    case contactDetailsEvents.edit.contactNumber.start:
    case contactDetailsEvents.edit.contactNumber.stop:
    case contactDetailsEvents.edit.contactNumber.cancel:
    case contactDetailsEvents.deletes.contactNumbers.contactNumber:
    case contactDetailsEvents.deletes.contactNumbers.modal:
    case contactDetailsEvents.deletes.contactNumbers.cancel:
      newState = adviserProfileContactDetailsEditorReducer(newState, action)
      newState = validateProfile(newState)
      return newState
    case workExperienceEvents.add.experience:
    case workExperienceEvents.edit.start:
    case workExperienceEvents.edit.stop:
    case workExperienceEvents.edit.cancel:
    case workExperienceEvents.set.experience:
    case workExperienceEvents.set.startMonth:
    case workExperienceEvents.set.endMonth:
    case workExperienceEvents.set.startYear:
    case workExperienceEvents.set.endYear:
    case workExperienceEvents.set.endDateCurrent:
    case workExperienceEvents.deletes.experience:
    case workExperienceEvents.deletes.modal:
    case workExperienceEvents.deletes.cancel:
      newState = adviserProfileWorkExperienceEditorReducer(newState, action)
      return newState
    case containerEvents.login.loggingIn:
      clearLocalStorageValues()
      newState.loginFailed = false
      return newState
    case containerEvents.login.loginFailed:
      newState.loading = false
      newState.loginFailed = true
      return newState
    case containerEvents.set.adviserId:
      newState.adviserId = action.adviserId
      return newState
    case containerEvents.login.loggedIn:
      newState.adviserId = getAdviserId()
      newState.adviserIsLoggedIn = true
      newState.adviserName = action.payload.adviserName
      newState.token = action.payload.token
      if (localStorage && action.payload.token) {
        localStorage.setItem('token', JSON.stringify(action.payload.token))
        localStorage.setItem('userName', action.payload.adviserName)
      }
      return newState
    case containerEvents.login.loggedOut:
      clearLocalStorageValues()
      newState.adviserIsLoggedIn = false
      newState.adviserName = ''
      newState.token = null
      //eslint-disable-next-line
      var logoutUrl = '/find-an-ifa/adviser/logout'
      window.location.replace(logoutUrl)
      return newState
    case containerEvents.edit.start:
      newState.editingProfile = true
      newState.submittingProfile = false
      newState.profileBeforeEditing = cloneDeep(newState.profile)
      return newState
    case containerEvents.edit.stop:
      newState.editingProfile = false
      newState.edited = false
      return newState
    case containerEvents.edit.cancel:
      newState.editingProfile = false
      newState.edited = false
      newState.profile = cloneDeep(newState.profileBeforeEditing)
      newState = adviserProfileEducationEditorReducer(newState, action)
      newState = adviserProfileWorkExperienceEditorReducer(newState, action)
      newState = adviserProfileContactDetailsEditorReducer(newState, action)
      return newState
    case containerEvents.submit.submitting:
      newState.submittingProfile = true
      return newState
    case containerEvents.submit.submitted:
      newState.submittingProfile = false
      newState.submittedProfile = true
      newState.editingProfile = false
      newState.edited = true
      newState = validateProfile(newState)
      return newState
    case containerEvents.fetch.contactNumberTypes:
      newState.allContactNumberTypes = action.payload
      newState.fetchedContactNumberTypes = true
      return newState
    case containerEvents.set.showProfileLockedModal:
      newState.showModal = true
      return newState
    case containerEvents.set.hideProfileLockedModal:
      newState.showModal = false
      return newState
    default:
      return state
  }
}

function getAdviserId () {
  let adviserId
  if (history) {
    const location = history.location
    const path = location.pathname
    const temp = path.substring(('/adviser/').length, path.length)
    adviserId = Number(temp.substring(0, temp.indexOf('/')))
  }
  return adviserId
}

function clearLocalStorageValues () {
  if (localStorage) {
    localStorage.removeItem('token')
    localStorage.removeItem('userName')
  }
}

function setProfileDefaults (profile) {
  if (!profile.investmentMinimums) {
    profile.investmentMinimums = {
      minimumMonthlyDebitOrder: 0,
      allowUnsureInvestors: false,
      minimumLumpSum: 0
    }
  }
  if (!profile.contactDetails) {
    profile.contactDetails = {
      contactNumbers: [],
      publicContactEmailAddress: ''
    }
  }
  return profile
}
